import { defineStore } from 'pinia'
import BlogsService from '~/services/BlogsService'

// const blogItemSchema = z.object({
//   id: z.number(),
//   title: z.string(),
//   slug: z.string(),
//   content: z.string(),
//   category: z.string(),
//   created_at: z.string(),
//   updated_at: z.string(),
//   published_at: z.string(),
//   image: z.string(),
// })

export const useBlogStore = defineStore('blog', () => {
  const category = ref('gates')
  const categories = ref(['gates', 'panels', 'wire', 'luca', 'gabions'])
  const blogItems = ref([])
  const loadingBlogItems = ref(false)
  const pagination = ref({
    page: 1,
    pages: 1,
    total: 0,
  })

  const allBlogsLoaded = computed(() => {
    return blogItems.value.length === pagination.value.total
  })

  async function fetchBlogItems(type, page) {
    loadingBlogItems.value = true
    const response = await BlogsService.getBlogItems({
      params: {
        type,
        page: page || pagination.value.page,
      },
    })

    blogItems.value = response.value.data
    pagination.value = response.value.meta
    loadingBlogItems.value = false
  }

  async function fetchMoreBlogItems(type) {
    loadingBlogItems.value = true

    const response = await useFetch('/api/blogs/', {
      params: {
        type,
        page: pagination.value.page + 1,
      },
    })

    if (response.value) {
    // blogItems.value = response.value.data
    // pagination.value = response.value.meta
    }
    loadingBlogItems.value = false
  }

  async function fetchBlogCategories() {
    categories.value = await BlogsService.getBlogCategories()
  }

  async function fetchBlogItem(slug) {
    console.log('fetchBlogItem', slug)
    const response = await BlogsService.getBlogItem(slug)
    if (!response.value) {
      throw createError({
        statusCode: 404,
        statusMessage: 'Blog item not found',
      })
    }
    return response.value.data
  }

  return {
    category,
    categories,
    allBlogsLoaded,
    pagination,
    blogItems,
    loadingBlogItems,
    fetchBlogItem,
    fetchBlogItems,
    fetchBlogCategories,
    fetchMoreBlogItems,
  }
})
